// src/app/store/useNotificationStore.ts
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import type { Notification } from '../../types/notification';

interface NotificationStore {
  // State
  selectedNotification: Notification | null;
  detailsDialogOpen: boolean;
  notificationActionLoading: boolean;

  // Actions
  setSelectedNotification: (notification: Notification | null) => void;
  setDetailsDialogOpen: (open: boolean) => void;
  setNotificationActionLoading: (loading: boolean) => void;
  openDetailsDialog: (notification: Notification) => void;
  closeDetailsDialog: () => void;
  clearNotificationData: () => void;
}

export const useNotificationStore = create<NotificationStore>()(
  devtools(
    (set) => ({
      // Initial State
      selectedNotification: null,
      detailsDialogOpen: false,
      notificationActionLoading: false,

      // Actions
      setSelectedNotification: (notification: Notification | null) => {
        set({ selectedNotification: notification }, false, 'setSelectedNotification');
      },

      setDetailsDialogOpen: (open: boolean) => {
        set({ detailsDialogOpen: open }, false, 'setDetailsDialogOpen');
      },

      setNotificationActionLoading: (loading: boolean) => {
        set({ notificationActionLoading: loading }, false, 'setNotificationActionLoading');
      },

      openDetailsDialog: (notification: Notification) => {
        set(
          {
            selectedNotification: notification,
            detailsDialogOpen: true,
          },
          false,
          'openDetailsDialog'
        );
      },

      closeDetailsDialog: () => {
        set(
          {
            detailsDialogOpen: false,
            selectedNotification: null,
          },
          false,
          'closeDetailsDialog'
        );
      },

      clearNotificationData: () => {
        set(
          {
            selectedNotification: null,
            detailsDialogOpen: false,
            notificationActionLoading: false,
          },
          false,
          'clearNotificationData'
        );
      },
    }),
    { name: 'NotificationStore' }
  )
);
